export default __webpack_public_path__ + "img/criPJrIF.77ebc01d.svg";